import { Checkbox, Typography, useTheme } from '@mui/material'
import {
    FlexBox,
    FlexBoxSpaceBetween,
    LazyRunnerColour
} from 'components/atoms'
import { TBetRunner, useBetContext } from 'contexts/BetContext'

export const RunnerOption = ({
    saddle,
    colors,
    horseName,
    liveOdd,
    associateVisible = false,
    baseChecked,
    onBaseChange,
    associateChecked,
    onAssociateChange,
    associateDisabled = false,
    running
}: TBetRunner & {
    associateVisible?: boolean
    baseChecked: boolean
    onBaseChange: (checked: boolean) => void
    associateChecked?: boolean
    associateDisabled?: boolean
    onAssociateChange?: (checked: boolean) => void
}) => {
    const theme = useTheme()
    const { mainColor } = useBetContext()
    const isRunning = running && liveOdd > 0

    return (
        <FlexBoxSpaceBetween
            sx={{
                height: 40,
                width: `calc(100% - ${theme.spacing(4)})`,
                px: 2,
                backgroundColor: '#F4F6FA',
                opacity: isRunning ? 1 : 0.5
            }}
        >
            <FlexBox>
                <Typography
                    sx={{
                        fontSize: 20,
                        fontWeight: 700,
                        width: 30,
                        textAlign: 'right',
                        pr: 1.5
                    }}
                >
                    {saddle}
                </Typography>
                <LazyRunnerColour
                    style={{ width: 20, verticalAlign: 'text-top' }}
                    src={colors}
                />
                <Typography variant="title-16-bold" sx={{ ml: 1 }}>
                    {horseName}
                </Typography>
            </FlexBox>
            <FlexBox>
                <Typography
                    variant="title-14-bold"
                    sx={{ color: '#434B5A', mr: 3 }}
                >
                    {isRunning ? liveOdd.toString().replace('.', ',') : ''}
                </Typography>
                <Checkbox
                    sx={{
                        width: 30,
                        height: 30,
                        color: `${mainColor} !important`
                    }}
                    checked={isRunning && baseChecked}
                    disabled={!isRunning}
                    onChange={() =>
                        isRunning && onBaseChange && onBaseChange(!baseChecked)
                    }
                />
                {associateVisible && (
                    <Checkbox
                        sx={{
                            width: 30,
                            height: 30,
                            color: `${mainColor} !important`
                        }}
                        checked={isRunning && associateChecked}
                        onChange={() =>
                            isRunning &&
                            onAssociateChange &&
                            onAssociateChange(!associateChecked)
                        }
                        disabled={!isRunning || associateDisabled}
                    />
                )}
            </FlexBox>
        </FlexBoxSpaceBetween>
    )
}
